/**
 * Global day / night state for the whole PorchLight world.
 * Survives yard navigation, map travel, and Friends switching.
 */

export type TimeOfDay = 'day' | 'night';

const BACKYARD_YARDS = new Set(['hubert', 'raleigh', 'spanish-fork']);

let globalTimeOfDay: TimeOfDay = 'day';

export function isTimeOfDayYard(yardId: string | null | undefined): boolean {
  return yardId != null && BACKYARD_YARDS.has(yardId);
}

/** Authoritative time of day for every backyard. */
export function timeOfDay(): TimeOfDay {
  return globalTimeOfDay;
}

/** Reads the shared global value (yard id is ignored). */
export function timeOfDayForYard(_yardId?: string): TimeOfDay {
  return globalTimeOfDay;
}

export function setTimeOfDay(value: TimeOfDay): TimeOfDay {
  globalTimeOfDay = value;
  return globalTimeOfDay;
}

export function toggleTimeOfDayForYard(_yardId: string): TimeOfDay {
  globalTimeOfDay = globalTimeOfDay === 'day' ? 'night' : 'day';
  return globalTimeOfDay;
}

export function resetTimeOfDayForTests(): void {
  globalTimeOfDay = 'day';
}

/** Open sky taps at or above this world Y toggle day/night. */
export const SKY_TAP_MAX_Y = 0.44;

/** Smooth day/night cross-fade (ms). */
export const TIME_OF_DAY_TRANSITION_MS = 1_500;
